import React from 'react'
import './Loader.css'
function Loader() {
  return (
    <>
      <div class="loading">
        <h2>Fecthing ...</h2>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </>
  )
}

export default Loader